import wings from "../images/vector-portfolio-03.svg";
import windmill from "../images/vector-portfolio-02.svg";
import clouds from "../images/vector-portfolio-01.svg";
import Typewriter from "typewriter-effect";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBehance, faFacebookF } from "@fortawesome/free-brands-svg-icons";
import { faLinkedinIn } from "@fortawesome/free-brands-svg-icons";
import { faInstagram } from "@fortawesome/free-brands-svg-icons";
import { faDiscord } from "@fortawesome/free-brands-svg-icons";
import { faGithub } from "@fortawesome/free-brands-svg-icons";
import mycv from "../asset/kevin-wines-cv.pdf";

import "../App.css";
const Hero = () => {
  return (
    <div className="h-[100vh] relative mt-36" id="hero">
      {/* text-container */}
      <p className="text-center text-4xl font-semibold h-[20%] my-10 md:h-[10%]">
        <Typewriter
          options={{
            strings: ["Hi, my name is Kevin", "Web Designer", "Web Developer"],
            autoStart: true,
            loop: true,
          }}
        />
      </p>

      {/* ------------------- */}
      {/* social media mobile */}
      {/* ------------------- */}
      <div className="text-2xl flex flex-wrap w-3/4 justify-center mx-auto gap-y-4 md:hidden">
        <a
          className="inline-block mx-2"
          href="https://www.linkedin.com/in/kevin-wines-77b0101a1/"
          target="_blank"
        >
          <span className="border border-black text-center w-12 h-12 rounded-[50%] flex justify-center place-items-center hover:border-[#7dce13] transition-all duration-300 group">
            <FontAwesomeIcon
              className="group-hover:text-[#7DCE13]"
              icon={faLinkedinIn}
            />
          </span>
        </a>
        <a
          className="inline-block mx-2"
          href="https://discord.com/users/625578554981351424"
          target="_blank"
        >
          <span className="border border-black text-center w-12 h-12 rounded-[50%] flex justify-center place-items-center hover:border-[#7dce13] transition-all duration-300 group">
            <FontAwesomeIcon
              className="group-hover:text-[#7DCE13]"
              icon={faDiscord}
            />
          </span>
        </a>
        <a
          className="inline-block mx-2"
          href="https://www.instagram.com/kjmwines/"
          target="_black"
        >
          <span className="border border-black text-center w-12 h-12 rounded-[50%] flex justify-center place-items-center hover:border-[#7dce13] transition-all duration-300 group">
            <FontAwesomeIcon
              className="group-hover:text-[#7DCE13]"
              icon={faInstagram}
            />
          </span>
        </a>
        <a
          className="inline-block mx-2"
          href="https://github.com/LightLotus"
          target="_blank"
        >
          <span className="border border-black text-center w-12 h-12 rounded-[50%] flex justify-center place-items-center hover:border-[#7dce13] transition-all duration-300 group">
            <FontAwesomeIcon
              className="group-hover:text-[#7DCE13]"
              icon={faGithub}
            />
          </span>
        </a>
        <a
          className="inline-block mx-2"
          href="https://www.facebook.com/kevinjoseph.wines/"
          target="_blank"
        >
          <span className="border border-black text-center w-12 h-12 rounded-[50%] flex justify-center place-items-center hover:border-[#7dce13] transition-all duration-300 group">
            <FontAwesomeIcon
              className="group-hover:text-[#7DCE13]"
              icon={faFacebookF}
            />
          </span>
        </a>
        <a
          className="inline-block mx-2"
          href="https://www.behance.net/kjmwines"
          target="_blank"
        >
          <span className="border border-black text-center w-12 h-12 rounded-[50%] flex justify-center place-items-center hover:border-[#7dce13] transition-all duration-300 group">
            <FontAwesomeIcon
              className="group-hover:text-[#7DCE13]"
              icon={faBehance}
            />
          </span>
        </a>
      </div>
      <a href={mycv} download={mycv}>
        <button className=" mt-10 md:mt-3 block w-1/2 md:w-48 mx-auto md:my-16  border hover:border-[#7dce13] uppercase shawdow bg-[#7dce13] p-3 transition-all duration-300 hover:shadow-xl hover:text-white">
          Download CV
        </button>
      </a>
      <div className="flex items-center flex-col h-1/4 relative mt-28 md:mt-10">
        <img
          src={clouds}
          className="absolute w-1/4 left-[60%] top-[-60%]  md:w-[10%] md:top-[-20%] md:left-[30%]"
          alt="logo"
        />
        {/* <img
          src={clouds}
          className="absolute w-1/4 right-[60%]  top-[-50%] md:w-[10%] md:top-[-20%] md:right-[30%]"
          alt="logo"
        /> */}
        <img
          src={wings}
          className="App-logo absolute top-[-10%] w-1/2  md:w-2/12 md:top-[-5%]"
          alt="logo"
        />
        <img src={windmill} className="windmill w-3/4 md:w-1/4" alt="" />
      </div>

      {/* ---------------------- */}
      {/* social media desktop */}
      {/* ---------------------- */}
      <div className="text-2xl hidden md:flex flex-col absolute top-0 left-0 px-12 mt-8">
        <a
          href="https://www.linkedin.com/in/kevin-wines-77b0101a1/"
          target="_blank"
        >
          <span className="border border-black text-center w-[3rem] h-[3rem] flex items-center justify-center hover:border-[#7DCE13] group rounded-[50%] my-2 transition-all duration-300">
            {" "}
            <FontAwesomeIcon
              className="group-hover:text-[#7DCE13]"
              icon={faLinkedinIn}
            />
          </span>
        </a>
        <a href="https://discord.com/users/625578554981351424" target="_blank">
          <span className="border border-black text-center w-[3rem] h-[3rem] flex items-center justify-center hover:border-[#7DCE13] group rounded-[50%] my-2 transition-all duration-300">
            {" "}
            <FontAwesomeIcon
              className="group-hover:text-[#7DCE13]"
              icon={faDiscord}
            />
          </span>
        </a>
        <a href="https://www.instagram.com/kjmwines/" target="_black">
          <span className="border border-black text-center w-[3rem] h-[3rem] flex items-center justify-center hover:border-[#7DCE13] group rounded-[50%] my-2 transition-all duration-300">
            {" "}
            <FontAwesomeIcon
              className="group-hover:text-[#7DCE13]"
              icon={faInstagram}
            />
          </span>
        </a>
        <a href="https://github.com/LightLotus" target="_blank">
          <span className="border border-black text-center w-[3rem] h-[3rem] flex items-center justify-center hover:border-[#7DCE13] group rounded-[50%] my-2 transition-all duration-300">
            {" "}
            <FontAwesomeIcon
              className="group-hover:text-[#7DCE13]"
              icon={faGithub}
            />
          </span>
        </a>
        <a href="https://www.facebook.com/kevinjoseph.wines/" target="_blank">
          <span className="border border-black text-center w-[3rem] h-[3rem] flex items-center justify-center hover:border-[#7DCE13] group rounded-[50%] my-2 transition-all duration-300">
            {" "}
            <FontAwesomeIcon
              className="group-hover:text-[#7DCE13]"
              icon={faFacebookF}
            />
          </span>
        </a>
        <a href="https://www.behance.net/kjmwines" target="_blank">
          <span className="border border-black text-center w-[3rem] h-[3rem] flex items-center justify-center hover:border-[#7DCE13] group rounded-[50%] my-2 transition-all duration-300">
            {" "}
            <FontAwesomeIcon
              className="group-hover:text-[#7DCE13]"
              icon={faBehance}
            />
          </span>
        </a>
      </div>
    </div>
  );
};

export default Hero;
